import { ReactNode, createContext, useContext } from 'react';
import { MenuModel } from '../../types/layout';

export interface SettingsContextProps {
  menu: MenuModel[];
}

const SettingsContext = createContext({} as SettingsContextProps);

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({
  menu,
  children,
}: {
  menu: MenuModel[];
  children: ReactNode;
}) => {
  return (
    <SettingsContext.Provider value={{ menu }}>
      {children}
    </SettingsContext.Provider>
  );
};
